import React, { memo } from 'react'

import LoadingBanner from '../LoadingBanner/LoadingBanner'

const UPLOADING_TITLE = 'Uploading your 3D model...'
const UPLOADING_DESCRIPTION =
  'This may take a moment. Complex models may take longer to load.'

function UploadingBannerState() {
  return (
    <LoadingBanner
      title={UPLOADING_TITLE}
      description={UPLOADING_DESCRIPTION}
      wrapperClassName="uploading-banner-state"
    />
  )
}

export default memo(UploadingBannerState)
